/**
 * Import additional modules here:
 *
 * import './module_xyz';
 */

import Media from "./helpers/matchMediaGenerator";
import readMoreAccs from './modules/readMoreAccs';
import scrollNav from './modules/scrollNav';
import peoplePopup from './modules/peoplePopup';
import backToTop from './modules/backToTop';
import cookiePolicy from './modules/cookiePolicy';


readMoreAccs.init();
scrollNav.init();
peoplePopup.init();
backToTop.init();
cookiePolicy.init();
